import React, { useState,useCallback } from 'react';
import { Button } from 'react-bootstrap';
import DepartmentDatatable from '../../modules/department/DepartmentDatatable';
import DepartmentModal from '../../modules/department/DepartmentModal';

const DepartmentsTab = (props) => {

    const [show , setShow]= useState( false );
    const [recordId, setRecordId ] = useState( "" );
    const dialogRef = React.createRef();
    
  
    

    const handleCallback  = useCallback(
        (id) => {
            setRecordId(id);       
            setShow(true);   
        },
        [], // Tells React to memoize regardless of arguments.
      );

    const modalCallback = (isShow) => {             
        setShow(isShow);       
    }

    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>
            <DepartmentDatatable                
                parentCallback={handleCallback}
                entityId={props.entityId}  
                ref={dialogRef}      
                modalShow={show}   
            />
            <DepartmentModal
                modal={show}
                parentCallback={modalCallback}
                selectedRecord={recordId}
                entityId={props.entityId}
                ref={dialogRef}
            />
            <Button
                bsStyle="primary"    
                className="ml-3 mt-3"
                onClick={() => handleCallback('')}
            >
            <i class="fas fa-plus"></i>
            </Button>
        </div>
      
    );
};

export default DepartmentsTab;